import { put, call, takeLatest } from "redux-saga/effects";
import { flashMessage } from "redux-flash";
import axios from "axios";

import {
  GET_CATEGORIES_REQUEST,
  getCategoriesSuccess,
  getCategoriesError,
  GET_CATEGORY_VIDEOS_REQUEST,
  getCategoryVideosSuccess,
  getCategoryVideosError,
} from "./actions";

import { logoutRequest } from "../../../../login/actions";
import { Env } from "../../../../../env";

function* getCategoriesRequest1(action) {
  const { accessToken, specialityId, userId } = action;
  let response;
  // console.log('final',specialityId)
  try {
    //response = yield call(axios.get, `${Env.BASE_API_URL}/Categories?filter={"where":{"specialityId":"${specialityId}"}}`, {
    response = yield call(
      axios.get,
      `${Env.BASE_API_URL}/Categories/getCategories?specialityId=${specialityId}&userId=${userId}`,
      {
        headers: { Authorization: accessToken },
      }
    );
  } catch (err) {
    if (err.response && err.response.status === 401) {
      yield put(logoutRequest());
    } else {
      yield put(
        getCategoriesError("Une erreur s'est produite, veuillez réessayer.")
      );
      yield put(flashMessage("Une erreur s'est produite, veuillez réessayer."));
    }

    return;
  }

  yield put(getCategoriesSuccess(response.data));
}

export function* watchGetCategoriesRequest() {
  yield takeLatest(GET_CATEGORIES_REQUEST, getCategoriesRequest1);
}

function* getCategoryVideosRequest1(action) {
  const { accessToken, categoryId, userId } = action;
  let response;
  // console.log(userId)
  try {
    response = yield call(
      axios.get,
      //`${Env.BASE_API_URL}/Categories/${categoryId}/videos?filter={"where":{"ownerId":"${userId}","isAd":false}}`,
      `${Env.BASE_API_URL}/Categories/getCategoryVideos?categoryId=${categoryId}&userId=${userId}&isAd=false`,
      {
        headers: { Authorization: accessToken },
      }
    );
  } catch (err) {
    if (err.response && err.response.status === 401) {
      yield put(logoutRequest());
    } else {
      yield put(
        getCategoryVideosError("Une erreur s'est produite, veuillez réessayer.")
      );
      yield put(flashMessage("Une erreur s'est produite, veuillez réessayer."));
    }

    return;
  }

  yield put(getCategoryVideosSuccess(response.data));
}

export function* watchGetCategoryVideosRequest() {
  yield takeLatest(GET_CATEGORY_VIDEOS_REQUEST, getCategoryVideosRequest1);
}



// WEBPACK FOOTER //
// ./src/pages/playlists/form/videos/video-chooser/saga.js